import { render } from "./PatientDashboard.vue?vue&type=template&id=588301ec&scoped=true"
import script from "./PatientDashboard.vue?vue&type=script&lang=js"
export * from "./PatientDashboard.vue?vue&type=script&lang=js"

import "./PatientDashboard.vue?vue&type=style&index=0&id=588301ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588301ec"]])

export default __exports__